import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import WhatsAppIllustration from "../../Assets/whatsapp-green.png";
import { FaWhatsapp, FaRobot, FaBullhorn, FaUserCheck, FaMoneyBillWave } from "react-icons/fa";

const WhatsAppProduct = () => {
  return (
    <>
      <Navbar />
      <main className="whatsapp-page" role="main">
      {/* Scoped styles for WhatsApp page */}
      <style>{`
        .whatsapp-page {
          background: #ffffff;
          color: #1f2937;
          min-height: 100vh;
        }

        /* Hero */
        .wa-hero {
          background: linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%);
          position: relative;
          overflow: hidden;
        }
        
        .wa-hero::before {
          content: '';
          position: absolute;
          top: -50%;
          right: -10%;
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(37, 211, 102, 0.08) 0%, transparent 70%);
          border-radius: 50%;
        }
        
        .wa-hero-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 4.5rem 1.5rem;
          display: flex;
          gap: 3rem;
          align-items: center;
          justify-content: space-between;
          position: relative;
          z-index: 1;
        }
        
        .wa-hero-left {
          flex: 1 1 55%;
          display: flex;
          flex-direction: column;
          gap: 1.25rem;
        }
        
        .wa-badge {
          display: inline-flex;
          align-items: center;
          gap: .6rem;
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          color: #ffffff;
          padding: .5rem 1rem;
          font-weight: 700;
          border-radius: 999px;
          width: fit-content;
          box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);
          font-size: 0.9rem;
        }
        
        .wa-badge svg {
          font-size: 1.1rem;
        }
        
        .wa-title {
          font-size: clamp(2.2rem, 5vw, 3.5rem);
          line-height: 1.15;
          font-weight: 900;
          margin: 0;
          background: linear-gradient(135deg, #128C7E 0%, #25D366 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        .wa-subtitle {
          font-size: clamp(1.05rem, 2.5vw, 1.2rem);
          line-height: 1.8;
          color: #4a5568;
          max-width: 50ch;
        }
        
        .wa-hero-right {
          flex: 1 1 45%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .wa-hero-illustration {
          width: 100%;
          max-width: 550px;
          height: auto;
          filter: drop-shadow(0 20px 40px rgba(37, 211, 102, 0.2));
          animation: float 6s ease-in-out infinite;
        }
        
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }

        /* Features Section */
        .wa-section {
          max-width: 1200px;
          margin: 0 auto;
          padding: 4rem 1.5rem 5rem 1.5rem;
          background: #ffffff;
        }
        
        .wa-section-header {
          text-align: center;
          margin-bottom: 3rem;
        }
        
        .wa-section-title {
          font-size: clamp(1.75rem, 4vw, 2.5rem);
          font-weight: 800;
          color: #1a202c;
          margin: 0 0 1rem 0;
        }
        
        .wa-section-subtitle {
          font-size: 1.1rem;
          color: #718096;
          max-width: 65ch;
          margin: 0 auto;
          line-height: 1.7;
        }
        
        .wa-section-underline {
          width: 100px;
          height: 4px;
          background: linear-gradient(90deg, #128C7E 0%, #25D366 100%);
          border-radius: 2px;
          margin: 1rem auto 0;
        }

        /* Features Grid */
        .wa-features-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1.75rem;
          margin-top: 2rem;
        }
        
        .wa-card {
          background: linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%);
          border: 2px solid #dcfce7;
          border-radius: 20px;
          padding: 2rem;
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }
        
        .wa-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #128C7E 0%, #25D366 100%);
          transform: scaleX(0);
          transition: transform 0.3s ease;
        }
        
        .wa-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(37, 211, 102, 0.15);
          border-color: #25D366;
        }
        
        .wa-card:hover::before {
          transform: scaleX(1);
        }
        
        .wa-card-icon {
          width: 56px;
          height: 56px;
          background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.75rem;
          color: #ffffff;
          margin-bottom: 1.25rem;
          box-shadow: 0 8px 20px rgba(37, 211, 102, 0.3);
          transition: all 0.3s ease;
        }
        
        .wa-card:hover .wa-card-icon {
          transform: scale(1.1) rotate(-5deg);
          box-shadow: 0 12px 28px rgba(37, 211, 102, 0.4);
        }
        
        .wa-card-title {
          margin: 0 0 1rem 0;
          font-size: 1.35rem;
          font-weight: 800;
          color: #1a202c;
        }
        
        .wa-card-description {
          line-height: 1.8;
          color: #4a5568;
          font-size: 1rem;
          margin: 0;
        }

        /* Highlight Section */
        .wa-highlight {
          background: linear-gradient(135deg, #dcfce7 0%, #f0fdf4 100%);
          border-radius: 24px;
          padding: 2.5rem;
          margin-top: 3rem;
          border: 2px solid #25D366;
          box-shadow: 0 12px 32px rgba(37, 211, 102, 0.15);
        }
        
        .wa-highlight-title {
          font-size: 1.5rem;
          font-weight: 800;
          color: #128C7E;
          margin: 0 0 1rem 0;
          display: flex;
          align-items: center;
          gap: 0.75rem;
        }
        
        .wa-highlight-title svg {
          font-size: 1.75rem;
          color: #25D366;
        }
        
        .wa-highlight-description {
          font-size: 1.05rem;
          line-height: 1.8;
          color: #2d3748;
          margin: 0;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .wa-hero-inner {
            padding: 3.5rem 1.25rem;
            gap: 2rem;
          }
          .wa-features-grid {
            gap: 1.5rem;
          }
        }
        
        @media (max-width: 768px) {
          .wa-hero-inner {
            flex-direction: column-reverse;
            text-align: center;
            gap: 2rem;
          }
          .wa-hero-left {
            align-items: center;
          }
          .wa-badge {
            align-self: center;
          }
          .wa-subtitle {
            text-align: center;
          }
          .wa-hero-right {
            width: 100%;
          }
          .wa-hero-illustration {
            max-width: 450px;
          }
          .wa-features-grid {
            grid-template-columns: 1fr;
          }
          .wa-highlight {
            padding: 2rem;
          }
        }
      `}</style>

      {/* Hero */}
      <section className="wa-hero">
        <div className="wa-hero-inner">
          <div className="wa-hero-left">
            <span className="wa-badge">
              <FaWhatsapp /> WhatsApp Business API
            </span>
            <h1 className="wa-title">Automated WhatsApp Communication</h1>
            <p className="wa-subtitle">
              Transform customer engagement with our intelligent WhatsApp automation platform. 
              From marketing campaigns to automated loan applications, deliver seamless, 
              conversational experiences that require zero human intervention—all through 
              the channel your customers already use and trust.
            </p>
          </div>

          <div className="wa-hero-right">
            <img
              src={WhatsAppIllustration}
              className="wa-hero-illustration"
              alt="WhatsApp Business automation interface"
              loading="eager"
            />
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="wa-section" aria-label="WhatsApp Features">
        <header className="wa-section-header">
          <h2 className="wa-section-title">Smart Communication at Scale</h2>
          <p className="wa-section-subtitle">
            Empower your lending business with intelligent WhatsApp automation that handles everything 
            from customer onboarding to collections—no agents required.
          </p>
          <div className="wa-section-underline" />
        </header>

        <div className="wa-features-grid">
          <article className="wa-card">
            <div className="wa-card-icon">
              <FaBullhorn />
            </div>
            <h3 className="wa-card-title">Broadcast Marketing</h3>
            <p className="wa-card-description">
              Send targeted marketing messages to thousands of customers instantly. 
              Promote new loan products, special offers, and financial services directly 
              to your audience's WhatsApp—with high open rates and engagement.
            </p>
          </article>

          <article className="wa-card">
            <div className="wa-card-icon">
              <FaRobot />
            </div>
            <h3 className="wa-card-title">Automated Onboarding</h3>
            <p className="wa-card-description">
              Fully automated customer onboarding with zero human intervention. 
              Customers can apply for loans, submit documents, and complete verification 
              entirely through WhatsApp's conversational interface.
            </p>
          </article>

          <article className="wa-card">
            <div className="wa-card-icon">
              <FaUserCheck />
            </div>
            <h3 className="wa-card-title">Real-Time Updates</h3>
            <p className="wa-card-description">
              Keep customers informed with instant loan status updates, payment reminders, 
              approval notifications, and disbursement confirmations—all delivered 
              automatically through WhatsApp.
            </p>
          </article>

          <article className="wa-card">
            <div className="wa-card-icon">
              <FaMoneyBillWave />
            </div>
            <h3 className="wa-card-title">Smart Collections</h3>
            <p className="wa-card-description">
              Automate payment reminders and collection workflows with intelligent 
              follow-ups. Send personalized payment notifications and handle customer 
              inquiries through conversational AI.
            </p>
          </article>
        </div>

        <div className="wa-highlight">
          <h3 className="wa-highlight-title">
            <FaWhatsapp /> No Agents, No Hassle
          </h3>
          <p className="wa-highlight-description">
            Our customizable WhatsApp automation handles the entire loan journey—from first contact 
            to final repayment. Customers apply for loans, upload documents, get instant credit 
            decisions, and manage their accounts directly through WhatsApp conversations. 
            It's lending made simple, accessible, and completely automated.
          </p>
        </div>
      </section>
    </main>
    <Footer />
    </>
  );
};

export default WhatsAppProduct;